
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/themes.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-themes-demo-light","docs-x-markdown-themes-demo-dark","docs-x-markdown-themes-demo-custom"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/themes.zh-CN.md?type=demo')
};